import React, { Component } from 'react'
import { apiProcess } from '../../../api/api.js'
import InsuranceCardInput from '../../documents/insuranceCardField'
import { INSURANCE } from '../main/constants.js'
import { Header, Button } from 'components/elements'
import './insuranceScreen.css'

class InsuranceScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      generalError: false,
      insuranceBack: null,
      insuranceFront: null,
      insuranceBackID: null,
      insuranceFrontID: null,
      insuranceError: false,
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(INSURANCE)
  }

  submitInsuranceEdits = () => {
    if (this.state.insuranceBackID == null || this.state.insuranceFrontID == null) {
      this.setState({
        insuranceError: true,
      })
      return false
    }

    let apiURL = 'users/documents'
    let profileData = {}
    profileData = {
      vehicle_insurance: {
        images: {
          insurance_card_front_image: {
            cloudinary_public_id: this.state.insuranceFrontID,
          },
          insurance_card_back_image: {
            cloudinary_public_id: this.state.insuranceBackID,
          },
        },
      },
    }

    apiProcess(apiURL, profileData, 'update-license-insurance', 'Update Insurance Information - Wizard Info Wizard')
      .then(
        function(responseData) {
          this.setState({
            insuranceError: false,
            generalError: false,
          })
          this.props.onSuccess()
        }.bind(this),
      )
      .catch(
        function(responseData) {
          this.setState({
            insuranceError: false,
            generalError: true,
          })
          //alert('check this when API is fixed.')
          //this.props.onSuccess()
        }.bind(this),
      )
  }

  changeInsurance = (side, imageURL, imageID) => {
    if (side === 'front') {
      this.setState({
        insuranceFront: imageURL,
        insuranceFrontID: imageID,
      })
    }

    if (side === 'back') {
      this.setState({
        insuranceBack: imageURL,
        insuranceBackID: imageID,
      })
    }
  }
  render() {
    const { loading, insuranceError, generalError } = this.state
    return (
      <div>
        {this.props.header && (
          <Header size={5} renderas="h2" className="mb-1">
            {this.props.header}
          </Header>
        )}
        {this.props.instructions && <p className="mb-4">{this.props.instructions}</p>}
        {!generalError && <div className="has-text-danger mb-4">{generalError}</div>}
        <InsuranceCardInput
          onChange={this.changeInsurance}
          error={insuranceError}
          //insuranceFront={insuranceFront}
          //insuranceBack={insuranceBack}
          showSubDescription={false}
        />
        <Button color="primary" loading={loading} disabled={loading} onClick={() => this.submitInsuranceEdits()}>
          Save Insurance Images
        </Button>
        {this.props.skippable && <div className="finger-pointer" onClick={() => this.props.onSuccess()}>I'll do this later</div>}
      </div>
    )
  }
}
export default InsuranceScreen

InsuranceScreen.defaultProps = {
  onSuccess: function() {},
  skippable: true,
  header: 'Insurance Cards',
  instructions: 'Because you declined additional insurance, you must upload your personal motorcycle insurance cards.',
  onScreenLoad: function() {},
}
